/**
 * queue/components/queueToast.tsx
 * Bottom-center dark toast matching the prototype: a mono tag chip + message,
 * auto-dismissed by the store after ~3.4s. Reads the store's current toast and
 * renders nothing when there isn't one.
 */

import React from 'react';
import { View, Text, Platform } from 'react-native';
import { useQueue } from '../store';
import { Mono } from './atoms';

export default function QueueToast() {
  const { toast } = useQueue();
  if (!toast) return null;
  return (
    <View
      pointerEvents="none"
      style={{
        position: 'absolute', left: 0, right: 0, bottom: 26, alignItems: 'center', zIndex: 90,
        ...(Platform.OS === 'web' ? { position: 'fixed' as any } : {}),
      }}
    >
      <View style={{
        flexDirection: 'row', alignItems: 'center', gap: 12, maxWidth: 520,
        backgroundColor: '#08090A', borderRadius: 11, paddingHorizontal: 18, paddingVertical: 12,
        ...(Platform.OS === 'web' ? { boxShadow: '0 14px 32px -10px rgba(0,0,0,.5)' } as any : {}),
      }}>
        <View style={{ borderWidth: 1, borderColor: '#2A2B2D', borderRadius: 5, paddingHorizontal: 6, paddingVertical: 2 }}>
          <Mono style={{ fontSize: 11, color: '#9B9B9F' }}>{toast.tag}</Mono>
        </View>
        <Text style={{ fontSize: 13.5, color: '#FFFFFF' }}>{toast.msg}</Text>
      </View>
    </View>
  );
}
